export default __webpack_public_path__ + "static/media/le_neubourg5.2794694f.jpg";